import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Button, InputAdornment, Icon, TextField, Grid } from '@mui/material';

class ForgetPasswordDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      username: "",
      email: "",
    };
    autoBind(this);
  }

  handleClose() {
    this.props.parent.setState({forgetPasswordDialogOpen: false});
    this.props.parent.state.forgetPasswordDialogOpen = false;
  }

  btnCancelClicked() {
    this.handleClose();
  }

  btnOKClicked() {
    if (this.validateInput()) {
      let requestObj = {
        username: this.state.username.trim(),
        email: this.state.email.trim(),
      };
      this.props.root.refs.API.request("user_forget_password", requestObj, this.forgetPasswordRequestOK, this.forgetPasswordRequestFailed);
    }
  }

  forgetPasswordRequestOK(res) {
    this.props.root.addNotification("Request Sent", true);
  }

  forgetPasswordRequestFailed(err) {
    console.log("forget password request failed");
    this.props.root.addNotification("Request Failed", false);
  }

  usernameChanged(e) {
    this.setState({
      username: e.target.value
    });
    this.state.username = e.target.value;
  }

  emailChanged(e) {
    this.setState({
      email: e.target.value
    });
    this.state.email = e.target.value;
  }

  validateInput() {
    let result = true;

    if (this.state.username.trim() == "" || this.state.email.trim() == "") {
      result = false;
    }

    return result;
  }

  render() {
      return (
        <div>
          <Dialog
            open={this.props.parent.state.forgetPasswordDialogOpen}
            onClose={this.handleClose}
          >
            <DialogTitle>
              Enter your username and email
            </DialogTitle>
            <DialogContent>
              Due to security reason, your password was encrypted. The system cannot read your password. To reset password, please enter your username and email here:
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={Localization.strings.USERNAME}
                    value={this.state.username}
                    onChange={this.usernameChanged}
                    InputProps={{
                      endAdornment: <InputAdornment position="end"><Icon>account_circle</Icon></InputAdornment>
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={Localization.strings.EMAIL}
                    value={this.state.email}
                    onChange={this.emailChanged}
                    InputProps={{
                      endAdornment: <InputAdornment position="end"><Icon>email</Icon></InputAdornment>
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{padding:'16px 24px'}}>
              <Button onClick={this.btnCancelClicked}>{Localization.strings.CANCEL}</Button>
              <Button
                onClick={this.btnOKClicked}
                color="primary"
                variant="contained"
              >
                {Localization.strings.OK}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
  }
}

export default ForgetPasswordDialog;
